import React from 'react'
import { Query } from 'react-apollo'
import GraphqlErrorHandler from './GraphqlErrorHandler'

const QueryWrap = ({ children, ...rest }) => (
  <Query {...rest} >
    {result => (
      <GraphqlErrorHandler error={result.error}>
        {children(result)}
      </GraphqlErrorHandler>
    )}
  </Query>
)

export { QueryWrap }



// WEBPACK FOOTER //
// ./src/components/error_handling/QueryWrap.js